import AccordionSimple from "@/components/AccordionSimple";
import {useAppState} from "@/store";
import {parseMergeTags} from "@/helpers";

export default function FaqStacked() {
    const content = window.ein?.content?.step_5 || {}
    const {faq_list} = content
    const {state} = useAppState()
    return (
        <>
            <div className="heading-h2 text-center mb-[24px]">
                {parseMergeTags(faq_list?.heading, state)}
            </div>
            <div className="grid grid-cols-1 gap-[24px]">
                {faq_list?.faqs && faq_list.faqs.map((faq, i) => (
                    <AccordionSimple key={i} title={parseMergeTags(faq.question, state)} content={parseMergeTags(faq.answer, state)} />
                ))}
            </div>
        </>
    )
}
